var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dv-skeleton",class:("variant-" + _vm.variant),attrs:{"aria-hidden":"true"}},_vm._l((_vm.renderCount),function(n){return _c('div',{key:n,staticClass:"dv-skeleton-item"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }